// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import vueResource from 'vue-resource'
import i18n from '@/libs/i18n'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import VueCompositionAPI from '@vue/composition-api'
import 'vue-select/dist/vue-select.css';
import moment from 'moment'
import VueClipboard from 'vue-clipboard2'
import { useMediaQuery } from '@vueuse/core'

// 3rd party plugins
import './libs/axios'

// Global Components
import './global-components'

// import core styles
require('./@core/scss/core.scss')

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

Vue.use(VueClipboard)

Vue.use(iView);
Vue.use(vueResource);
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true,
  position: "top-right",
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
});

Vue.prototype.rootHost = "https://icoapidashboard.panaroma.finance";     
Vue.prototype.host = "https://icoapidashboard.panaroma.finance";

// Vue.prototype.lpHost = "http://localhost:8000";


Vue.prototype.moment = moment
Vue.prototype.useMediaQuery = useMediaQuery
  
Vue.http.interceptors.push((request, next) => {
  //After the login is successful, the TOKEN returned in the background is saved locally, and the stored TOKEN value is obtained from the sessionStorage for each request
  request.headers.set('x-auth-token', localStorage.getItem('TOKEN'));
  var appLoading = document.getElementById('loading-bg')
  appLoading.style.display = 'block'
  // store.commit('setLoader', true);
  next((response) => {
    //You need to obtain the TOKEN value returned by the background when logging in to the pole verification
        var xAuthToken = response.headers.get('x-auth-token');
        if (xAuthToken != null && xAuthToken != '') {
          localStorage.setItem('TOKEN', xAuthToken);
        }
        
        if (response.body.code == '4000' || response.body.code == '3000') {
          appLoading.style.display = 'none' 
          store.commit('setMember', null);
          localStorage.removeItem("Email");
          localStorage.setItem("TokenName", null)
          store.commit('setAccount', null);
          store.commit('setAddress', null);
          store.commit('setBalance', null);
          store.commit('setChainId', null);
          store.commit('setConvertedBalance', 0);
          store.commit('setConvertedPurchased', 0);
          store.commit('setConvertedReferral', 0);
          store.commit('setTotalSupply', 0);
          router.push('/login');
          return false;
        }
        // store.commit('setLoader', false);
        appLoading.style.display = 'none'
        return response;
    });
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js